import React, { FC } from 'react'

import { BLACK_COLOR } from '../../../utils/constants'

const CloseImageFullscreenIcon: FC = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <circle
        cx="35"
        cy="35"
        r="25"
        fill="white"
      />
    </g>
    <path
      d="M27.1765 26.1329L27.2803 26.2197L35 33.9395L42.7197 26.2197C43.0126 25.9268 43.4874 25.9268 43.7803 26.2197C44.0407 26.48 44.0696 26.8842 43.8671 27.1765L43.7803 27.2803L36.0605 35L43.7803 42.7197C44.0732 43.0126 44.0732 43.4874 43.7803 43.7803C43.52 44.0407 43.1158 44.0696 42.8235 43.8671L42.7197 43.7803L35 36.0605L27.2803 43.7803C26.9874 44.0732 26.5126 44.0732 26.2197 43.7803C25.9593 43.52 25.9304 43.1158 26.1329 42.8235L26.2197 42.7197L33.9395 35L26.2197 27.2803C25.9268 26.9874 25.9268 26.5126 26.2197 26.2197C26.48 25.9593 26.8842 25.9304 27.1765 26.1329Z"
      fill={BLACK_COLOR}
    />
  </svg>

)

export default CloseImageFullscreenIcon
